import { Observable } from 'rxjs';

import { SnCamera } from '@lib/api/entities';

import { IFsMap } from '../types';

export interface DevicesResponse<T = unknown> {
  devices: T[];
  status: number;
  correlationId?: string;
  partnerId?: string;
}

export abstract class FsMapPresenceDevicesServiceProvider<
  TMap extends IFsMap,
  TMarker = unknown,
  TDevice = unknown,
> {
  // Streams
  public abstract get dock$(): Observable<TMarker>;
  public abstract get dockNearbyCameras$(): Observable<SnCamera>;
  public abstract get hovered$(): Observable<TMarker>;
  public abstract get mouseOut$(): Observable<void>;

  public abstract selectMarkerByDeviceId$(deviceId: string): Observable<TMarker>;

  // Data
  public abstract get advancedMarkers(): TMarker[];

  // Lifecycle
  public abstract onMapLoaded(map: TMap): void;
  public abstract addToMap(): void;
  public abstract removeFromMap(): void;

  // Actions
  public abstract viewOnMap(marker: TMarker): void;
  public abstract findMarkerAndSelect(marker: TMarker): void;
  public abstract deselect(marker: TMarker): void;
  public abstract openDeviceHistory(marker: TMarker): void;
  public abstract dockStream(marker: TMarker): void;
  public abstract setupListeners(): void;

  // Data fetcher (shadow mode)
  public abstract getDevicesForShadowMode(
    bbox: string[],
    zoom?: number,
  ): Observable<DevicesResponse<TDevice>>;
}
